import {propertyTypes} from "@/services/properties";

const codes = {
  prodottoProperty: "1",
  piuTariffeProperty: "2",
  codProdCollegatoProperty: "3",
  compagniaProperty: "4",
  canaleProperty: "5",
  distributoriProperty: "6",
  modDistribuzioneProperty: "7",
  mercatoProperty: "8",
  destinatariProperty: "9",
  targetMarketProperty: "10",
  descProdottoProperty: "11",
  lineaBusinessProperty: "12",
  ramoProperty: "13",
  tipologiaGaranzieProperty: "14",
  combinazioneGaranzieProperty: "15",
  prodCommercioProperty: "16",
  inizioCommProperty: "17",
  fineCommProperty: "18",
  edizioneDIPAggProperty: "19",
  tipologiaAssicurazioneProperty: "20",
  premioTipologiaProperty: "21",
  premioDescProperty: "22",
  frazPremioProperty: "23",
  durataProperty: "24",
  etaMaxAllaSottoscrizioneProperty: "25",
  etaMaxAllaScadenzaProperty: "26",
  docRichiestaProperty: "27",
  rischiAssicuratiRamoVitaProperty: "28",
  rischiAssicuratiRamoDanniProperty: "29",
  decessoQualsiasiCausaProperty: "30",
  decessoQualsiasiCausaPrestazioneProperty: "31",
  decessoDaInfortunioProperty: "32",
  decessoDaInfortunioPrestazioneProperty: "33",
  decessoDaMalattiaProperty: "34",
  decessoDaMalattiaPrestazioneProperty: "35",
  invaliditaPermanenteQualsiasiCausaProperty: "36",
  invaliditaPermanenteQualsiasiCausaPrestazioneProperty: "37",
  invaliditaPermanenteDaInfortunioProperty: "38",
  invaliditaPermanenteDaInfortunioPrestazioneProperty: "39",
  invaliditaPermanenteDaMalattiaProperty: "40",
  invaliditaPermanenteDaMalattiaPrestazioneProperty: "41",
  inabilitaTemporaneaQualsiasiCausaProperty: "42",
  inabilitaTemporaneaQualsiasiCausaPrestazioneProperty: "43",
  inabilitaTemporaneaDaInfortunioProperty: "44",
  inabilitaTemporaneaDaInfortunioPrestazioneProperty: "45",
  inabilitaTemporaneaDaMalattiaProperty: "46",
  inabilitaTemporaneaDaMalattiaPrestazioneProperty: "47",
  malattieGraviProperty: "48",
  malattieGraviPrestazioneProperty: "49",
  ricoveroOspedalieroProperty: "50",
  ricoveroOspedalieroPrestazioneProperty: "51",
  ricoveroGrandeInterventoChirurgicoProperty: "52",
  ricoveroGrandeInterventoChirurgicoPrestazioneProperty: "53",
  perditaImpiegoProperty: "54",
  perditaImpiegoPrestazioneProperty: "55",
  altriRischiProperty: "56",
  speseEmissioneProperty: "64",
  costiRamoVitaProperty: "57",
  costiRamoDanniProperty: "58",
  specificheCaricamentiProperty: "65",
  interessiFrazProperty: "59",
  altriCostiProperty: "66",
  retrDistrVitaProperty: "60",
  retrDistrDanniProperty: "61",
  retrDistrSpecificheProperty: "62",
  noteProperty: "63",
};

const properties = {

  prodottoProperty: {
    code: codes.prodottoProperty,
    name: "Prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  piuTariffeProperty: {
    code: codes.piuTariffeProperty,
    name: "Più versioni prodotto",
    description: "",
    order: 1,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  codProdCollegatoProperty: {
    code: codes.codProdCollegatoProperty,
    name: "Codice prodotti collegati",
    description: "",
    order: 2,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  compagniaProperty: {
    code: codes.compagniaProperty,
    name: "Compagnia",
    description: "",
    order: 3,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  canaleProperty: {
    code: codes.canaleProperty,
    name: "Canale",
    description: "",
    order: 4,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  distributoriProperty: {
    code: codes.distributoriProperty,
    name: "Distributori",
    description: "",
    order: 5,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  modDistribuzioneProperty: {
    code: codes.modDistribuzioneProperty,
    name: "Modalità di distribuzione",
    description: "",
    order: 6,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  mercatoProperty: {
    code: codes.mercatoProperty,
    name: "Mercato",
    description: "",
    order: 7,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  destinatariProperty: {
    code: codes.destinatariProperty,
    name: "Destinatari",
    description: "",
    order: 8,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  targetMarketProperty: {
    code: codes.targetMarketProperty,
    name: "Target Market",
    description: "",
    order: 9,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  descProdottoProperty: {
    code: codes.descProdottoProperty,
    name: "Descrizione prodotto",
    description: "",
    order: 10,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  lineaBusinessProperty: {
    code: codes.lineaBusinessProperty,
    name: "Linea di business",
    description: "",
    order: 11,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  ramoProperty: {
    code: codes.ramoProperty,
    name: "Ramo",
    description: "",
    order: 12,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaGaranzieProperty: {
    code: codes.tipologiaGaranzieProperty,
    name: "Tipologia garanzie",
    description: "",
    order: 13,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  combinazioneGaranzieProperty: {
    code: codes.combinazioneGaranzieProperty,
    name: "Combinazione garanzie",
    description: "",
    order: 14,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  prodCommercioProperty: {
    code: codes.prodCommercioProperty,
    name: "Prodotto in commercio",
    description: "",
    order: 15,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  inizioCommProperty: {
    code: codes.inizioCommProperty,
    name: "Inizio commercializzazione",
    description: "",
    order: 16,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  fineCommProperty: {
    code: codes.fineCommProperty,
    name: "Fine commercializzazione",
    description: "",
    order: 17,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  edizioneDIPAggProperty: {
    code: codes.edizioneDIPAggProperty,
    name: "Edizione DIP aggiuntivo",
    description: "",
    order: 18,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaAssicurazioneProperty: {
    code: codes.tipologiaAssicurazioneProperty,
    name: "Tipologia di assicurazione",
    description: "",
    order: 19,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  premioTipologiaProperty: {
    code: codes.premioTipologiaProperty,
    name: "Premio - Tipologia",
    description: "",
    order: 20,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  premioDescProperty: {
    code: codes.premioDescProperty,
    name: "Premio - Descrizione",
    description: "",
    order: 21,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  frazPremioProperty: {
    code: codes.frazPremioProperty,
    name: "Frazionamento del premio",
    description: "",
    order: 22,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  durataProperty: {
    code: codes.durataProperty,
    name: "Durata contrattuale",
    description: "",
    order: 23,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  etaMaxAllaSottoscrizioneProperty: {
    code: codes.etaMaxAllaSottoscrizioneProperty,
    name: "Età massima alla sottoscrizione",
    description: "",
    order: 24,
    value: "",
    valueSign: "anni",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  etaMaxAllaScadenzaProperty: {
    code: codes.etaMaxAllaScadenzaProperty,
    name: "Età massima alla scadenza",
    description: "",
    order: 25,
    value: "",
    valueSign: "anni",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  docRichiestaProperty: {
    code: codes.docRichiestaProperty,
    name: "Documentazione richiesta",
    description: "",
    order: 26,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  rischiAssicuratiRamoVitaProperty: {
    code: codes.rischiAssicuratiRamoVitaProperty,
    name: "Rischi Assicurati Ramo Vita",
    description: "",
    order: 27,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  rischiAssicuratiRamoDanniProperty: {
    code: codes.rischiAssicuratiRamoDanniProperty,
    name: "Rischi Assicurati Ramo Danni",
    description: "",
    order: 28,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoQualsiasiCausaProperty: {
    code: codes.decessoQualsiasiCausaProperty,
    name: "Decesso Qualsiasi Causa",
    description: "",
    order: 29,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoQualsiasiCausaPrestazioneProperty: {
    code: codes.decessoQualsiasiCausaPrestazioneProperty,
    name: "Decesso Qualsiasi Causa - Prestazione",
    description: "",
    order: 30,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoDaInfortunioProperty: {
    code: codes.decessoDaInfortunioProperty,
    name: "Decesso Da Infortunio",
    description: "",
    order: 31,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoDaInfortunioPrestazioneProperty: {
    code: codes.decessoDaInfortunioPrestazioneProperty,
    name: "Decesso Da Infortunio - Prestazione",
    description: "",
    order: 32,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoDaMalattiaProperty: {
    code: codes.decessoDaMalattiaProperty,
    name: "Decesso Da Malattia",
    description: "",
    order: 33,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoDaMalattiaPrestazioneProperty: {
    code: codes.decessoDaMalattiaPrestazioneProperty,
    name: "Decesso Da Malattia - Prestazione",
    description: "",
    order: 34,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteQualsiasiCausaProperty: {
    code: codes.invaliditaPermanenteQualsiasiCausaProperty,
    name: "Invalidità Permanente (qualsiasi causa)",
    description: "",
    order: 35,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteQualsiasiCausaPrestazioneProperty: {
    code: codes.invaliditaPermanenteQualsiasiCausaPrestazioneProperty,
    name: "Invalidità Permanente (qualsiasi causa) - Prestazione",
    description: "",
    order: 36,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteDaInfortunioProperty: {
    code: codes.invaliditaPermanenteDaInfortunioProperty,
    name: "Invalidità Permanente da Infortunio",
    description: "",
    order: 37,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteDaInfortunioPrestazioneProperty: {
    code: codes.invaliditaPermanenteDaInfortunioPrestazioneProperty,
    name: "Invalidità Permanente da Infortunio - Prestazione",
    description: "",
    order: 38,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteDaMalattiaProperty: {
    code: codes.invaliditaPermanenteDaMalattiaProperty,
    name: "Invalidità Permanente da Malattia",
    description: "",
    order: 39,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteDaMalattiaPrestazioneProperty: {
    code: codes.invaliditaPermanenteDaMalattiaPrestazioneProperty,
    name: "Invalidità Permanente da Malattia - Prestazione",
    description: "",
    order: 40,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaQualsiasiCausaProperty: {
    code: codes.inabilitaTemporaneaQualsiasiCausaProperty,
    name: "Inabilità Temporanea (qualsiasi causa)",
    description: "",
    order: 41,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaQualsiasiCausaPrestazioneProperty: {
    code: codes.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty,
    name: "Inabilità Temporanea (qualsiasi causa) - Prestazione",
    description: "",
    order: 42,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaInfortunioProperty: {
    code: codes.inabilitaTemporaneaDaInfortunioProperty,
    name: "Inabilità Temporanea da infortunio",
    description: "",
    order: 43,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaInfortunioPrestazioneProperty: {
    code: codes.inabilitaTemporaneaDaInfortunioPrestazioneProperty,
    name: "Inabilità Temporanea da infortunio - Prestazione",
    description: "",
    order: 44,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaMalattiaProperty: {
    code: codes.inabilitaTemporaneaDaMalattiaProperty,
    name: "Inabilità Temporanea da malattia",
    description: "",
    order: 45,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaMalattiaPrestazioneProperty: {
    code: codes.inabilitaTemporaneaDaMalattiaPrestazioneProperty,
    name: "Inabilità Temporanea da malattia - Prestazione",
    description: "",
    order: 46,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  malattieGraviProperty: {
    code: codes.malattieGraviProperty,
    name: "Malattie gravi",
    description: "",
    order: 47,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  malattieGraviPrestazioneProperty: {
    code: codes.malattieGraviPrestazioneProperty,
    name: "Malattie gravi - Prestazione",
    description: "",
    order: 48,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  ricoveroOspedalieroProperty: {
    code: codes.ricoveroOspedalieroProperty,
    name: "Ricovero ospedaliero",
    description: "",
    order: 49,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  ricoveroOspedalieroPrestazioneProperty: {
    code: codes.ricoveroOspedalieroPrestazioneProperty,
    name: "Ricovero ospedaliero - Prestazione",
    description: "",
    order: 50,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  ricoveroGrandeInterventoChirurgicoProperty: {
    code: codes.ricoveroGrandeInterventoChirurgicoProperty,
    name: "Ricovero per Grande Intervento Chirurgico",
    description: "",
    order: 51,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  ricoveroGrandeInterventoChirurgicoPrestazioneProperty: {
    code: codes.ricoveroGrandeInterventoChirurgicoPrestazioneProperty,
    name: "Ricovero per Grande Intervento Chirurgico - Prestazione",
    description: "",
    order: 52,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  perditaImpiegoProperty: {
    code: codes.perditaImpiegoProperty,
    name: "Perdita d'impiego",
    description: "",
    order: 53,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  perditaImpiegoPrestazioneProperty: {
    code: codes.perditaImpiegoPrestazioneProperty,
    name: "Perdita d'impiego - Prestazione",
    description: "",
    order: 54,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  altriRischiProperty: {
    code: codes.altriRischiProperty,
    name: "Altri rischi",
    description: "",
    order: 55,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  speseEmissioneProperty: {
    code: codes.speseEmissioneProperty,
    name: "Spese di emissione",
    description: "",
    order: 56,
    value: "",
    valueSign: "",
    valueSignLeft: true,
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 4
  },
  costiRamoVitaProperty: {
    code: codes.costiRamoVitaProperty,
    name: "Caricamento Ramo Vita",
    description: "",
    order: 57,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 4
  },
  costiRamoDanniProperty: {
    code: codes.costiRamoDanniProperty,
    name: "Caricamento Ramo Danni",
    description: "",
    order: 58,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 4
  },
  specificheCaricamentiProperty: {
    code: codes.specificheCaricamentiProperty,
    name: "Specifiche caricamenti",
    description: "",
    order: 59,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 4
  },
  interessiFrazProperty: {
    code: codes.interessiFrazProperty,
    name: "Interessi di frazionamento",
    description: "",
    order: 60,
    value: "",
    values: [],
    valueDescription: "",
    frazionamento: {
      mensile: "", mensileSign: "%",
      bimestrale: "", bimestraleSign: "%",
      trimestrale: "", trimestraleSign: "%",
      quadrimestrale: "", quadrimestraleSign: "%",
      semestrale: "", semestraleSign: "%",
    },
    type: propertyTypes.FRAZIONAMENTO,
    sectionName: "Costi",
    sectionIndex: 4
  },
  altriCostiProperty: {
    code: codes.altriCostiProperty,
    name: "Altri costi",
    description: "",
    order: 61,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 4
  },
  retrDistrVitaProperty: {
    code: codes.retrDistrVitaProperty,
    name: "Retrocessione alla distribuzione - Ramo Vita",
    description: "",
    order: 62,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 5
  },
  retrDistrDanniProperty: {
    code: codes.retrDistrDanniProperty,
    name: "Retrocessione alla distribuzione - Ramo Danni",
    description: "",
    order: 63,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 5
  },
  retrDistrSpecificheProperty: {
    code: codes.retrDistrSpecificheProperty,
    name: "Retrocessione alla distribuzione - Specifiche",
    description: "",
    order: 64,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 5
  },
  // Note
  noteProperty: {
    code: codes.noteProperty,
    name: "Note",
    description: "",
    order: 65,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Note",
    sectionIndex: 6
  },
};

export {codes};
export default properties;
